<template>
  <section>
    <form class="columns local-lm-filters-columns">
      <div class="column is-2">
        <order-bo-filter />
      </div>
      <div class="column is-2" v-if="$route.name === 'Dispatch'">
        <movimenta-delivery-state-filter />
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-button
          class="lm-default-btn-outline-green--without-width lm-default-btn-delete"
          icon-right="close"
          size="is-small"
          @click.prevent="cleanFilters"
        />
        <b-button
          class="lm-default-btn-outline-green--without-width"
          icon-right="magnify"
          size="is-small"
          @click.prevent="submitData"
        />
      </div>
    </form>
  </section>
</template>
<script>
import { mixin } from '@/mixins'

import OrderBoFilter from '@/components/filters/OrderBoFilter'
import MovimentaDeliveryStateFilter from '@/components/filters/MovimentaDeliveryStateFilter'

export default {
  name: 'Filters',
  components: {
    OrderBoFilter,
    MovimentaDeliveryStateFilter
  },
  mixins: [
    mixin.notifications
  ],
  computed: {
    type () {
      return this.$attrs.type
    }
  },
  mounted () {
    this.$eventBus.$on('getOrders', async () => {
      this._getAvailableOrders()
    })
    this.$eventBus.$on('getAvailableOrders', async () => {
      this._getAvailableOrders()
    })
    this.$eventBus.$on('onPageChange', async (page) => {
      this._getAvailableOrders()
    })
  },
  methods: {
    async _getAvailableOrders () {
      const filters = await this.$store.getters['filters/filtersSelected']
      const type = this.type

      const orders = await this.$store.dispatch('orders/getAvailableOrders', { filters, type })
      if (!orders) return this.wrong(this.$t(orders.errorText))

      const totalCount = this.$store.getters['orders/totalCount']
      if (orders && totalCount === 0) this.$eventBus.$emit('emptyOrders')
      if (orders && totalCount) this.$eventBus.$emit('orders')
    },
    async submitData () {
      const filters = await this.$store.getters['filters/filtersSelected']
      if (!filters.supplierOrderCode && !filters.deliveredEffectiveStatusList) return this.wrong(this.$t('Errors.someFilterNeeded'))

      this.$store.dispatch('filters/resetPage')
      this._getAvailableOrders()
    },
    cleanFilters () {
      this.$store.dispatch('filters/flush')
      this.$store.dispatch('orders/flushAvailableOrders')
      this._getAvailableOrders()

      this.$eventBus.$emit('cleanFilters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/Filters.vue